import React from 'react';
import Slider from "react-slick";
import avatar1 from '../../../images/avatar/avatar_11.webp'
import avatar2 from '../../../images/avatar/avatar_10.webp'
import avatar3 from '../../../images/avatar/avatar_9.webp'
import avatar4 from '../../../images/avatar/avatar_8.webp'
import Bg from '../../../images/icons/icon_quote_2.svg'
import abImg1 from '../../../images/about.png'
import testo1 from '../../../images/testo1.png'
import star from '../../../images/star.png'

import { Button } from 'reactstrap'

import { Link } from "react-router-dom";

const testimonial = [
    {
        id: '01',
        Des: "Working with Techco was a game-changer for our business. Their  tailored solutions and dedicated support propelled us to new heights",
        Title: 'Sarah Johnson',
        sub: 'Board Member, UNIQA',
        avatar: avatar1,
    },
    {
        id: '02',
        Des: "Working with Techco was a game-changer for our business. Their  tailored solutions and dedicated support propelled us to new heights",
        Title: 'Adam Pedro',
        sub: 'Board Member, UNIQA',
        avatar: avatar2,
    },
    {
        id: '03',
        Des: "Working with Techco was a game-changer for our business. Their  tailored solutions and dedicated support propelled us to new heights",
        Title: 'Alkira Jemin',
        sub: 'Board Member, UNIQA',
        avatar: avatar3,
    },
    {
        id: '04',
        Des: "Working with Techco was a game-changer for our business. Their  tailored solutions and dedicated support propelled us to new heights",
        Title: 'Adam Pedro',
        sub: 'Board Member, UNIQA',
        avatar: avatar4,
    },
    {
        id: '05',
        Des: "Working with Techco was a game-changer for our business. Their  tailored solutions and dedicated support propelled us to new heights",
        Title: 'Adam Pedro',
        sub: 'Board Member, UNIQA',
        avatar: avatar2,
    },
]

const BusinessTestimonial = () => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const settings = {
        dots: false,
        arrows: false,
        speed: 1000,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        responsive: [
            {
                breakpoint: 1500,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const slider = React.useRef(null);



    return (
        <section className="review_and_about_section">

            {/* <div className="container">
                <div className="review_bg_box bg-success" style={{ backgroundImage: `url(${Bg})` }}>
                    <div className="heading_block text-center text-white">
                        <h2 className="heading_text mb-0">
                            Few Stories from our Client
                        </h2>
                    </div>
                    <div className="review_4col_carousel swiper">
                        <Slider ref={slider} {...settings}>
                            {testimonial.map((testimonial, tsm) => (
                                <div className="review_block_3" key={tsm}>
                                    <ul className="rating_block unordered_list">
                                        <li><i className="fa-solid fa-star fa-fw"></i></li>
                                        <li><i className="fa-solid fa-star fa-fw"></i></li>
                                        <li><i className="fa-solid fa-star fa-fw"></i></li>
                                        <li><i className="fa-solid fa-star fa-fw"></i></li>
                                        <li><i className="fa-solid fa-star fa-fw"></i></li>
                                    </ul>
                                    <p className="review_commtent">
                                        "{testimonial.Des}"
                                    </p>
                                    <div className="review_admin">
                                        <div className="review_admin_image">
                                            <img src={testimonial.avatar} alt="Maverick Phoenix" />
                                        </div>
                                        <div className="review_admin_info">
                                            <h4 className="review_admin_name">{testimonial.Title}</h4>
                                            <span className="review_admin_designation">{testimonial.sub}</span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>
            </div> */}
            
                <div className="container">
                    <div className="row align-items-center justify-content-lg-around">
                        <div className="col-lg-5">
                            <span className="sub_heading">About Us</span>
                            <br/>
                            <br/>
                            <div className="heading_block">
                                <h2 className="heading_text">
                                    Your AI SEO Partner
                                </h2>
                                <p className="heading_description text-dark pe-lg-5">
                                    At Digi Pexel, we’re not just another SEO agency; we’re pioneers in AI-powered SEO. With over 10+ years of experience and a track record of helping 150+ companies transform their organic presence, we know what it takes to win in today’s AI-driven search landscape.
                                </p>
                                <p className="heading_description mb-0 text-dark pe-lg-5">
                                    We specialize in AI SEO for B2B and SaaS companies, blending traditional SEO expertise with AEO (Answer Engine Optimization) and GEO (Generative Engine Optimization) strategies. From boosting rankings to getting cited in AI search results, we deliver proven results that translate into real pipeline growth, Quotations, and revenue.
                                </p>
                                <Button className='read_more' style={{marginLeft:'0px',marginTop:'20px'}}>Contact Now</Button>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="about_image_3">
                                <img className="image_wrap" src={abImg1} alt="Business Consulting" />
                            </div>
                        </div>
                    </div>

                    <div className="row align-items-center justify-content-lg-around section_space">
                        <div className='col-lg-12 text-center'>
                            <span className="sub_heading">Testimonials</span>
                            <br/>
                            <br/>
                            <h2 className="heading_text">
                                What Our Users Say
                            </h2>
                        </div>

                        <div className='col-md-4'>

                            <div className='testcommen_css bg_1'>
                                <ul className='testi1'>
                                    <li><img src={testo1} className='testo_img' /></li>
                                    <li>
                                        <img src={star} />
                                        <p>Jitendra Bhati</p>
                                        <p>Owner SRJ Heatt Exchangers India Pvt. Ltd</p>
                                    </li>
                                </ul>
                                <p className="heading_description testo_desp">Digi Pexel fixed our technical SEO, cleaned our backlinks, and built a strong AI SEO strategy. We’re now ranking again and getting high-quality leads.</p>
                            </div>

                            <div className='testcommen_css bg_2'>
                                <ul className='testi1'>
                                    <li><img src={testo1} className='testo_img' /></li>
                                    <li>
                                        <img src={star} />
                                        <p>Rajat</p>
                                        <p>Sales Head, Aroma Monk</p>
                                    </li>
                                </ul>
                                <p className="heading_description testo_desp">Digi Pexel helped us with the SEO and Marketing, and we are satisfied with the result. Now we just focus on the business development part, and the marketing part is taken care of by the Digi Pexel.</p>
                            </div>

                            <div className='testcommen_css bg_3'>
                                <ul className='testi1'>
                                    <li><img src={testo1} className='testo_img' /></li>
                                    <li>
                                        <img src={star} />
                                        <p>Madhur Maheswari</p>
                                        <p>Owner, GNC Exports</p>
                                    </li>
                                </ul>
                                <p className="heading_description testo_desp">Digi Pexel helped us in building a good website and helped us in getting organic visibility on the internet.</p>
                            </div>


                            <div className='testcommen_css bg_4'>
                                <ul className='testi1'>
                                    <li><img src={testo1} className='testo_img' /></li>
                                    <li>
                                        <img src={star} />
                                        <p>Anzar</p>
                                        <p>Marketing Head, Ease My Hotel</p>
                                    </li>
                                </ul>
                                <p className="heading_description testo_desp">Digi Pexel helped us build a content-first growth engine that actually converts. Our demos are up, CAC is down.</p>
                            </div>

                            <div className='testcommen_css bg_5'>
                                <ul className='testi1'>
                                    <li><img src={testo1} className='testo_img' /></li>
                                    <li>
                                        <img src={star} />
                                        <p>Jessica Brown</p>
                                        <p>Founder, Maple Essentials</p>
                                    </li>
                                </ul>
                                <p className="heading_description testo_desp">I run an eCommerce business in Canada, and after collaborating with Digi Pexel, our sales from organic traffic have doubled within a year.</p>
                            </div>

                            <div className='testcommen_css bg_6'>
                                <ul className='testi1'>
                                    <li><img src={testo1} className='testo_img' /></li>
                                    <li>
                                        <img src={star} />
                                        <p>Oliver Smith</p>
                                        <p>SaaS Founder, UK</p>
                                    </li>
                                </ul>
                                <p className="heading_description testo_desp">The professionalism and results delivered by Digi Pexel are outstanding. Our manufacturing ERP SaaS now ranks in the top 3 for most target keywords.</p>
                            </div>

                        </div>

                        <div className='col-md-4'>

                            <div className='testcommen_css bg_4'>
                                <ul className='testi1'>
                                    <li><img src={testo1} className='testo_img' /></li>
                                    <li>
                                        <img src={star} />
                                        <p>Shadab</p>
                                        <p>Co-founder, Arrow Gifter</p>
                                    </li>
                                </ul>
                                <p className="heading_description testo_desp">Digi Pexel rebuilt our local presence from the ground up. We now feature in the Map Pack and get steady sales even outside festive peaks.</p>
                            </div>

                            <div className='testcommen_css bg_3'>
                                <ul className='testi1'>
                                    <li><img src={testo1} className='testo_img' /></li>
                                    <li>
                                        <img src={star} />
                                        <p>Harshad</p>
                                        <p>Owner, Farmoduct</p>
                                    </li>
                                </ul>
                                <p className="heading_description testo_desp">Digi Pexel built the right foundation for exports—our brand now shows up for the right queries in GCC and Africa, and RFQs are from serious buyers.</p>
                            </div>

                            <div className='testcommen_css bg_1'>
                                <ul className='testi1'>
                                    <li><img src={testo1} className='testo_img' /></li>
                                    <li>
                                        <img src={star} />
                                        <p>Harshit Singh</p>
                                        <p>Business Head Nutrition Cult</p>
                                    </li>
                                </ul>
                                <p className="heading_description testo_desp">It has been more than 18 months now, and we are working with Digi Pexel, who really helped in fixing our SEO pain.</p>
                            </div>

                            <div className='testcommen_css bg_2'>
                                <ul className='testi1'>
                                    <li><img src={testo1} className='testo_img' /></li>
                                    <li>
                                        <img src={star} />
                                        <p>David Matias</p>
                                        <p>Owner, Tuluma Rivera Maya Tour</p>
                                    </li>
                                </ul>
                                <p className="heading_description testo_desp">I am running a tourism business in Mexico, and after having Digi Pexel as our SEO partner, we are seeing good organic results.</p>
                            </div>

                            <div className='testcommen_css bg_4'>
                                <ul className='testi1'>
                                    <li><img src={testo1} className='testo_img' /></li>
                                    <li>
                                        <img src={star} />
                                        <p>Arjun Mehta</p>
                                        <p>CEO, Aroma Traders, India</p>
                                    </li>
                                </ul>
                                <p className="heading_description testo_desp">Vinay and his team fixed our technical SEO issues and created a clear content plan. Now, our B2B perfume export orders have grown significantly.</p>
                            </div>

                            <div className='testcommen_css bg_3'>
                                <ul className='testi1'>
                                    <li><img src={testo1} className='testo_img' /></li>
                                    <li>
                                        <img src={star} />
                                        <p>Farhan Ali</p>
                                        <p>Owner, Leather Craft Exports, India</p>
                                    </li>
                                </ul>
                                <p className="heading_description testo_desp">We hired Digi Pexel to handle our SEO for leather products, and within months, we started receiving export orders from Europe.</p>
                            </div>

                        </div>

                        <div className='col-md-4'>
                            
                            <div className='testcommen_css bg_3'>
                                <ul className='testi1'>
                                    <li><img src={testo1} className='testo_img' /></li>
                                    <li>
                                        <img src={star} />
                                        <p>Shafa</p>
                                        <p>Business Development Head, Indonesia</p>
                                    </li>
                                </ul>
                                <p className="heading_description testo_desp">We are very happy with the SEO and Marketing service by Vinay and his team it worked for us in getting export orders for our essential oils.</p>
                            </div>

                            <div className='testcommen_css bg_5'>
                                <ul className='testi1'>
                                    <li><img src={testo1} className='testo_img' /></li>
                                    <li>
                                        <img src={star} />
                                        <p>Ramesh Gupta,</p>
                                        <p>Director, Textile Exports, India</p>
                                    </li>
                                </ul>
                                <p className="heading_description testo_desp">We partnered with Digi Pexel six months ago, and their SEO expertise has helped us grow our B2B leads consistently.</p>
                            </div>

                            <div className='testcommen_css bg_6'>
                                <ul className='testi1'>
                                    <li><img src={testo1} className='testo_img' /></li>
                                    <li>
                                        <img src={star} />
                                        <p>Maria Lopez</p>
                                        <p>Marketing Head, Spain</p>
                                    </li>
                                </ul>
                                <p className="heading_description testo_desp">Our hotel chain struggled with online visibility, but after working with Vinay and team, our bookings through organic search have gone up remarkably.</p>
                            </div>


                            <div className='testcommen_css bg_4'>
                                <ul className='testi1'>
                                    <li><img src={testo1} className='testo_img' /></li>
                                    <li>
                                        <img src={star} />
                                        <p>Ahmed Khan</p>
                                        <p>Export Manager, UAE</p>
                                    </li>
                                </ul>
                                <p className="heading_description testo_desp">Digi Pexel has been instrumental in building our SEO presence in the US and Europe. We are now ranking for highly competitive industrial fabric keywords.</p>
                            </div>

                            <div className='testcommen_css bg_3'>
                                <ul className='testi1'>
                                    <li><img src={testo1} className='testo_img' /></li>
                                    <li>
                                        <img src={star} />
                                        <p>Samuel Ochieng</p>
                                        <p>Business Owner, Kenya</p>
                                    </li>
                                </ul>
                                <p className="heading_description testo_desp">We were new to SEO, but Digi Pexel guided us at every step. Today, we get continuous inquiries from Africa for our solar structures.</p>
                            </div>

                            <div className='testcommen_css bg_1'>
                                <ul className='testi1'>
                                    <li><img src={testo1} className='testo_img' /></li>
                                    <li>
                                        <img src={star} />
                                        <p>Sofia Rahman</p>
                                        <p>International Sales Manager, Bangladesh</p>
                                    </li>
                                </ul>
                                <p className="heading_description testo_desp">Digi Pexel is not just an SEO agency; they are growth partners. Our essential oils brand now gets consistent inquiries from the US and Middle East.</p>
                            </div>
                        </div>

                        <div className='col-md-12 text-center'>
                            <Button className='read_more'>Contact Now</Button>
                        </div>

                    </div>
                </div>
        </section>
    );
}

export default BusinessTestimonial;